const MuiFormControlLabel = {
    label: {
        marginBottom: '0px',
    },
};

export default MuiFormControlLabel;
